import { AprState } from "@reducers/types/HRM/apr-state";

import { GET_APR, CREATE_APR, DELETE_APR } from "@actions/HRM/employee/types";
import { AprActions } from "@actions/HRM/employee/apr-actions";

import { AprType } from "@type/HRM/apr";
import {
  getInitialState,
  getRequestingState,
  getSuccessState,
  getFailedState,
} from "@utils/store";

const initialState: AprState = { ...getInitialState() };

const resetStates = {
  createAprSuccess: false,
  createAprFailed: false,
  deleteAprSuccess: false,
  deleteAprFailed: false,
};

const AprReducer = (state = initialState, action: AprActions): AprState => {
  switch (action.type) {
    case GET_APR.GET_APR_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: null,
          getAprRequestOngoing: true,
          getAprSuccess: false,
          getAprFailed: false,
        }),
      };

    case GET_APR.GET_APR_SUCCESS: {
      const { payload } = action as any;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getAprRequestOngoing: false,
          getAprSuccess: true,
          getAprFailed: false,
        }),
      };
    }

    case GET_APR.GET_APR_FAILED:
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          data: null,
          getAprRequestOngoing: false,
          getAprSuccess: false,
          getAprFailed: true,
        }),
      };

    case CREATE_APR.CREATE_APR_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          createAprRequestOngoing: true,
          createAprSuccess: false,
          createAprFailed: false,
        }),
      };

    case CREATE_APR.CREATE_APR_SUCCESS: {
      const { payload } = action as any;

      const currentData = state && state.data ? state.data : [];
      const updatedData = [...currentData, payload.data];

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          createAprRequestOngoing: false,
          createAprSuccess: true,
          createAprFailed: false,
        }),
      };
    }

    case CREATE_APR.CREATE_APR_FAILED:
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          createAprRequestOngoing: false,
          createAprSuccess: false,
          createAprFailed: true,
        }),
      };

    case DELETE_APR.DELETE_APR_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteAprRequestOngoing: true,
          deleteAprSuccess: false,
          deleteAprFailed: false,
        }),
      };

    case DELETE_APR.DELETE_APR_SUCCESS: {
      const { payload } = action as any;

      const updatedData =
        state && state.data
          ? state.data.filter((item: AprType) => item.id !== payload?.data)
          : [];

      return {
        ...getSuccessState({
          data: updatedData,
          deleteAprRequestOngoing: false,
          deleteAprSuccess: true,
          deleteAprFailed: false,
        }),
      };
    }

    case DELETE_APR.DELETE_APR_FAILED:
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          data: null,
          deleteAprRequestOngoing: false,
          deleteAprSuccess: false,
          deleteAprFailed: true,
        }),
      };

    default:
      return state;
  }
};

export default AprReducer;
